import { Checkbox } from 'primereact/checkbox';
import { Controller, useFormContext } from 'react-hook-form';
import { AccessForm } from '../../../Interfaces/admin/Role.interfaces';
import { RegisterFormFields } from './RegisterForm';
import { useRef, useState } from 'react';
import { Tooltip } from 'primereact/tooltip';
import ReportIcons from './ReportIcons';
import EditReportDialog from './EditReportDialog';

type ReportOptionProps = {
  item: AccessForm;
  index: number;
};

const ReportOption = ({ item, index }: ReportOptionProps) => {
  const [showEdit, setShowEdit] = useState(false);
  const { control } = useFormContext<RegisterFormFields>();
  const defaultEdit = item.editOption ? item.editOption[0].value : undefined;
  const tooltipRef = useRef<Tooltip>(null);
  const optionClassName = `icon-tooltip-${index}`;

  return (
    <div
      key={item.report}
      className="flex flex-column gap-2 align-items-start mt-2 capitalize flex-wrap"
    >
      <div className="flex gap-2 align-items-center">
        <Controller
          render={({ field }) => (
            <Checkbox
              inputId={item.report}
              checked={field.value}
              inputRef={field.ref}
              onChange={(e) => {
                field.onChange(e.checked);
              }}
            />
          )}
          name={`access.${index}.selected`}
          control={control}
        />
        <label htmlFor={item.report} className="text-17px">
          {item.label}
        </label>
        {(item.notification || item.editOption || item.approvalOption) && (
          <i
            className={`pi pi-pencil text-bluwaiBlue cursor-pointer text-17px ${optionClassName}`}
            onClick={() => {
              setShowEdit(true);
            }}
            data-pr-position="right"
            data-pr-tooltip="Edit"
          />
        )}
      </div>
      <ReportIcons
        showNotification={!!item.notification}
        showApproval={!!item.approvalOption}
        showEdit={!!item.editOption}
        iconClassName={optionClassName}
        optionIndex={index}
        defaultEdit={defaultEdit}
      />
      <EditReportDialog
        show={showEdit}
        hide={() => {
          setShowEdit(false);
        }}
        header={item.label}
        report={item.report}
        index={index}
        showNotification={!!item.notification}
        showApproval={!!item.approvalOption}
        editOption={item.editOption}
        defaultEdit={defaultEdit}
      />

      <Tooltip target={`.${optionClassName}`} ref={tooltipRef} />
    </div>
  );
};

export default ReportOption;
